import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import '../../stylesheets/navbar.css';


function menu_click(x) {
  console.log("Clicked!");
  x.classList.toggle("change");
}

const Navigation = () => (

    <ul class="navbar">
      <span class="title">Security Project</span>
      <div class="button_container"
      onClick={() => console.log("Menu Button Clicked")}
        >
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
      </div>
      <div id ="slideMenu" class="slideMenu">
        <li>
          <Link to={ROUTES.SIGN_IN}>Sign In</Link>
        </li>
        <li>
          <Link to={ROUTES.LANDING}>Map</Link>
        </li>
        <li>
          <Link to={ROUTES.HOME}>Home</Link>
        </li>
        <li>
          <Link to={ROUTES.ACCOUNT}>Account</Link>
        </li>
        <li>
          <Link to={ROUTES.ADMIN}>Admin</Link>
        </li>
      </div>
    </ul>
);
export default Navigation;
